import { createSlice } from '@reduxjs/toolkit'

import { RequestStatus } from '../../../config/constants'
import { EventState } from './event.type'

// `fetchEvent` a disparu : il lisait `users/me/` pour en tirer un événement, et
// personne ne le déclenchait. L'événement vit dans le stockage de l'app
// (`appConfig.getEvent()`), rempli au scan du QR code.

export const initialState: EventState = {
	event: {
		name: '',
		settings: {
			gradient: {
				from: '#ff0000',
				to: 'transparent'
			},
			event: '',
			background: '',
			menuColor: {
				background: 'rgba(196,10,10,0.6)',
				button: '#ff0000'
			},
			backgroundColor: '#000000'
		}
	},
	status: RequestStatus.IDLE,
	error: null
}

const eventSlice = createSlice({
	name: 'event',
	initialState,
	reducers: {}
})

const { reducer } = eventSlice

export default reducer
